// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2LIE0","rootSmall":"AddTileButton_rootSmall__7zzKN"};